import { SomethingWentWrong } from '@pflegenavi/web-components';
import type { FC, PropsWithChildren } from 'react';
import { useNavigate } from 'react-router-dom';
import { fmAppMainPages } from '@pflegenavi/frontend/routing';
import * as Sentry from '@sentry/react';

const ErrorBoundary: FC<PropsWithChildren> = ({ children }) => {
  const navigate = useNavigate();

  return (
    <Sentry.ErrorBoundary
      fallback={({ resetError, error }) => (
        <SomethingWentWrong
          handleGoHomeClick={() => {
            resetError();
            navigate(fmAppMainPages.HOME);
          }}
          supportEmail="help@pflegenavi.at"
          errorMessage={
            error instanceof Error ? error?.message : JSON.stringify(error)
          }
        />
      )}
    >
      {children}
    </Sentry.ErrorBoundary>
  );
};

export default ErrorBoundary;
